export enum TaskGroupedWidgetEnum {
  BY_TAG = 'tags',
  BY_TEMPLATE = 'template',
  BY_STATUS = 'status',
}
